// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/slide-tray/cm_default.scss
// module id = 325
// module chunks = 0